// import css before other
// files to preserve ordering
import './bundle.account.css';

// import FC deps
import '@account-atoms/Icon/IconSet';
// import '@lib/theme-handler';
//import '@lib/offline-runtime';

// import element js
import FieldMask from './elements/modifiers/FieldMask/FieldMask';
import FormValidation from './elements/modifiers/FormValidation/FormValidation';
import RadioToggle from './elements/modifiers/RadioToggle/RadioToggle';

// program
const html = document.querySelector('html');

// remove no-js class
html.classList.remove('no-js');

// initialize components js
function componentSetup() {
  const jsValidationForms = document.getElementsByClassName('form--validate');
  const jsValidationFormsLen = jsValidationForms.length;
  for (let i = jsValidationFormsLen; i--;) {
    FormValidation({ el: jsValidationForms[i] });
  }

  const fieldMasks = document.getElementsByClassName('FieldMask');
  for (let i = 0; i < fieldMasks.length; i++) {
    FieldMask({ el: fieldMasks[i] });
  }

  const radioToggles = document.querySelectorAll('input[type="radio"].RadioToggle');
  for (let i = 0; i < radioToggles.length; i++) {
    RadioToggle({ el: radioToggles[i] });
  }
}

document.addEventListener('DOMContentLoaded', componentSetup);
